import { normalizeRuleset, type Ruleset, type RulesetRepository } from '@texas42/app-model';
import type { Texas42Database } from '../db.js';
import { STORE_RULESETS } from '../constants.js';
import { listEnvelopes, readEnvelopeOrNull, writeEnvelope } from '../envelope-io.js';
import type { WriteQueue } from '../write-queue.js';
import { StorageUnavailableError } from '../storage-errors.js';

export function createIndexedDbRulesetRepository(
  db: Texas42Database,
  queue: WriteQueue,
): RulesetRepository {
  return {
    async save(ruleset) {
      await writeEnvelope(queue, db, STORE_RULESETS, ruleset);
    },

    async get(id) {
      const stored = await readEnvelopeOrNull<Ruleset>(db, STORE_RULESETS, id, 'ruleset', id);
      return stored ? normalizeRuleset(stored) : null;
    },

    async list() {
      const rulesets = await listEnvelopes<Ruleset>(db, STORE_RULESETS, 'ruleset', (r) => r.id);
      return rulesets.map(normalizeRuleset).sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
    },

    async delete(id) {
      await queue.enqueue(async () => {
        try {
          await db.delete(STORE_RULESETS, id);
        } catch (error) {
          throw new StorageUnavailableError('Unable to delete ruleset.', error);
        }
      });
    },
  };
}
